<template lang="pug">
el-card.dashboard-total-count-card
  .campaign-dashboard__list-summary
    .icon-container
      i.iconfont(:class="icon")
    div(style="height: 67px")
      span {{ $t(title) }}
      span {{ count }}
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default () {
        return 0
      }
    },
    title: {
      type: String,
      default () {
        return ''
      }
    },
    icon: {
      type: String,
      default () {
        return ''
      }
    }
  }
}
</script>

<style lang="stylus">
.dashboard-total-count-card
  .campaign-dashboard__list-summary
    display flex
    align-items center
    margin-left 18px
    div
      &:nth-child(2)
        span
          display block
          &:first-child
            font-size 13px
            color #808080
          &:last-child
            font-size 36px
            color #2883e0
</style>
